import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TokenLoginComponent } from './token/token-login.component';
import { ErrorComponent } from './error/error.component';
import { EnterEmailComponent } from './enter-email/enter-email.component';
import { ApplyComponent } from './apply/apply.component';
import { SuccessComponent } from './success/success.component';
import { NotActiveComponent } from './not-active/not-active.component';

const routes: Routes = [
  { path: 'enter-email', component: EnterEmailComponent }, // Korak 1
  { path: 'token-login/:token', component: TokenLoginComponent }, // Korak 2
  { path: 'apply/:token', component: ApplyComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'success', component: SuccessComponent },
  { path: 'not-active', component: NotActiveComponent },
  { path: '', redirectTo: '/enter-email', pathMatch: 'full' }, // Default ruta
  { path: '**', redirectTo: '/error' }, // Nepostojeće rute

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }

